import React, { useContext, useState } from "react";
import NumberInput from "common/NumberInput";
import Modal from "common/Modal";
import BqnContext from "common/BqnContext";

const BqnIdModal = ({ onClose }) => {
  const { bqnId } = useContext(BqnContext);

  const [error, setError] = useState(null);
  const [bqn, setBqn] = useState(bqnId);

  const apply = () => {
    setError(null);
    if (isNaN(bqn) || Number(bqn) < 0 || Number(bqn) > 254) {
      return setError("BQN ID must be a number between 0 and 255");
    }

    if (parseFloat(bqn) === parseFloat(bqnId)) {
      return onClose();
    }

    showModalConfirm(
      "Modify BQN ID?",
      `Do you confirm you want to change the BQN ID to ${bqn}? This will cause the BQN to reload the software, resulting in a traffic interruption of 10 seconds to 2 minutes, depending on the number of interfaces, CPU cores, and memory size.`,
      "refresh",
      function () {
        ifCl
          .run(`system bqn id ${bqn} force`)
          .then(() => {
            return onClose();
          })
          .catch((error) => {
            if (error.indexOf("%ERR-EPERM") !== -1) {
              setError("Cannot change the BQN ID within an active cluster");
            } else {
              setError(error);
            }
          });
      },
      () => {
        onClose();
      }
    );
  };

  return (
    <Modal
      title="Modify BQN ID"
      superIcon="device_hub"
      large={true}
      className="title-no-transform"
      content={() => {
        return (
          <div className="row clearfix margin-b-40">
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
              <div className="form-group margin-b-0">
                <NumberInput
                  name="newBqnId"
                  label="New BQN ID (0-255):"
                  defaultValue={bqn}
                  onChange={(e) => setBqn(e.target.value)}
                  className="input-control margin-b-0"
                  hideArrows={true}
                />
              </div>
            </div>
          </div>
        );
      }}
      applyLabel="OK"
      onApply={apply}
      closeLabel="CANCEL"
      onClose={onClose}
      footerMessage={
        (error !== null && (
          <span className="modal-err-msg color-red align-left">{error}</span>
        )) ||
        null
      }
    />
  );
};

export default BqnIdModal;
